const mutations = {
  setActa(state, data) {
    state.acta = data;
  },

  setModels(state, data) {
    state.alumnoExamens = data.items;
    state.pagination = data._meta;
  },

  setModel(state, data) {
    state.alumnoExamen = data;
  },

  addModel(state, model) {
    state.record.nuevo = true;
    state.alumnoExamens.unshift(model);
  },

  updateModel(state, model) {
    state.model = model;
    state.record.actualizado = true;
  },

  delModel(state, id) {
    const removeIndex = state.alumnoExamens
      .map(function (item) {
        return item.id;
      })
      .indexOf(id);
    state.alumnoExamens.splice(removeIndex, 1);
  },

  setErrors(state, errors) {
    state.errorArray = errors;
  },

  setFields(state, data) {
    state.fields = data.fields;
    state.emptyModel = data.model;
  },
};
export default mutations;
